import { create } from 'zustand';

import { createTreeSlice, type TreeSlice } from '~/components/v2/store/shared/createTreeSlice';

export const useLocationsFilterStore = create<TreeSlice>()((...args) => ({
  ...createTreeSlice({ treeItems: [] })(...args),
}));
